import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-user-add",
  templateUrl: "./med-icon-user-add.component.html",
})
export class MedIconUserAddComponent extends SvgMixinComponent {}
